<template>
    <div class="edit-form">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 v-loading="formLoading"
                 label-width="120px">
            <el-form-item label="数据集名称" prop="ruleName">
                <el-input v-model="dataForm.displayName" placeholder="数据集名称"></el-input>
            </el-form-item>
            <el-form-item label="数据集代码" prop="ruleCode">
                <el-input v-model="dataForm.datasetCode" placeholder="数据集代码"></el-input>
            </el-form-item>
            <el-form-item label="数据集表名" prop="tableName">
              <el-input v-model="dataForm.tableName" placeholder="数据集表名"></el-input>
            </el-form-item>
            <el-form-item label="父级代码" prop="description">
              <el-input v-model="dataForm.parentDatasetCode" placeholder="父级数据集代码"></el-input>
            </el-form-item>
            <el-form-item label="自动生成父级数据：" >
              <el-switch v-model="dataForm.enableAddPnode" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="排序">
                <el-input v-model="dataForm.dataSort" placeholder="排序"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
  export default {
    props: {
      dataSetId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        formLoading: false,
        dataForm: {
          id: '',
          displayName: '',
          datasetCode: '',
          parentDatasetCode: '',
          enableAddPnode: 0,
          tableName: '',
          dataSort: ''
        },
        dataRule: {
          displayName: [
            {required: true, message: '数据集名称不能为空', trigger: 'blur'}
          ],
          datasetCode: [
            {required: true, message: '数据集代码不能为空', trigger: 'blur'}
          ],
          tableName: [
            {required: true, message: '数据集表名不能为空', trigger: 'blur'}
          ],
        }
      }
    },
    mounted() {
      this.dataForm.id = this.dataSetId
      this.loadData()
    },
    methods: {
      loadData() {
        this.formLoading = true
        this.$http({
          url: this.$http.adornUrl('/customform/tablemeta/get?id=' + this.dataForm.id),
          method: 'get',
            baseURL: '',
        }).then(({data}) => {
          if (data && data.code === '1') {
            this.dataForm = data.data
          } else {
            this.dataForm = {
              id: ''
            }
          }
          this.formLoading = false
        })
      },
      dataFormSubmit() {
        if (this.dataForm.enableAddPnode==1&&!this.dataForm.parentDatasetCode){
          this.$message.error("请填写父级编码！");
          return
        }
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl('/customform/tablemeta/save'),
              method: 'post',
                baseURL: '',
              data: {
                'id': this.dataForm.id,
                'displayName': this.dataForm.displayName,
                'datasetCode': this.dataForm.datasetCode,
                'parentDatasetCode': this.dataForm.parentDatasetCode,
                'enableAddPnode': this.dataForm.enableAddPnode,
                'tableName': this.dataForm.tableName,
                'dataSort': this.dataForm.dataSort || 10
              }
            }).then(({data}) => {
              if (data && data.code === '1') {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
